
<select class="form-control" [name]="name" (change)="setStatus(statusSelect?.value)" #statusSelect>
    <!-- <option value="-">Select Status</option> -->
    <option *ngFor="let item of getStatusList()" 
        [value]="item" 
        [selected]="item==value">
            {{item}}
    </option>
</select>
